import { render, staticRenderFns } from "./TabModal.vue?vue&type=template&id=51f74998&"
import script from "./TabModal.vue?vue&type=script&lang=js&"
export * from "./TabModal.vue?vue&type=script&lang=js&"
import style0 from "./TabModal.vue?vue&type=style&index=0&id=51f74998&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports